module.exports = __webpack_public_path__ + "static/media/hanked.48d661c3.svg";